import React, { useEffect, useCallback, useState } from "react";
import { TextField, MenuItem, Select, FormControl, InputLabel, Grid } from "@mui/material";

const ParameterForm = ({ data, setParameterState }) => {

  const [defaultState, setDefaultState] = useState({})

  useEffect(() => {
    setDefaultState(data)
  }, [data])

  // Use callback for state updates
  const handleChange = useCallback(
    (field, value) => {
      setDefaultState((prevState) => ({
        ...prevState,
        [field]: typeof prevState[field] === "object" && prevState[field]?.default !== undefined
          ? { ...prevState[field], default: value } 
          : value,
      }));
    },
    [setDefaultState]
  );

  // Sync state when data changes
  useEffect(() => {
    setParameterState(defaultState);
  }, [defaultState]);

  const renderField = useCallback(([key, value]) => {
    const isSelect = Array.isArray(value.options);
    const fieldValue = value.default || value || "";

    return (
      <Grid key={key} item xs={2}>
        <FormControl fullWidth>
          {isSelect ? (
            <>
              <InputLabel>{key}</InputLabel>
              <Select
                value={fieldValue}
                onChange={(e) => handleChange(key, e.target.value)}
                sx={{ height: '45px', '& .MuiSelect-select': { height: '45px !important' } }}
                label={key}
              >
                {value.options.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </>
          ) : (
            <TextField
              type={typeof value === "number" ? "number" : "text"}
              label={key}
              value={fieldValue}
              onChange={(e) => handleChange(key, e.target.value)}
            />
          )}
        </FormControl>
      </Grid>
    );
  }, [handleChange, defaultState]);

  return (
    <>
      {Object.entries(defaultState).map(renderField)}
    </>
  );
};

export default ParameterForm;